export default "__VITE_ASSET__C3uMeT1O__"